/* ============================================================
   FGC PC BUILDER -> REDIRECT CONTACT -> AUTO SUBMIT (FIX LOADER)
   Paste this whole file into your theme custom JS (theme.liquid / custom.js).
   ============================================================ */

/* =========================
   1) PC BUILDER PAGE SCRIPT
========================= */
(function () {
  const root = document.querySelector('.fgc-section-custompc-page');
  if (!root) return;

  const formData = { steps: {} };

  const steps = [...root.querySelectorAll('.multi-column__item')]
    .filter(it => it.querySelector('.multi-column__text-container'));
  steps.forEach(s => s.classList.add('fgc-step'));

  const track = root.querySelector('.fgc-progress');
  const bar = root.querySelector('.fgc-progress__bar');
  const TOTAL_PROGRESS = 5;

  let idx = 0;
  let syncing = false;

  // ===== Step error UI (under options) =====
  const STEP_ERR_TEXT = 'Please select an option to continue';

  function stepErrorEl(stepEl) {
    if (!stepEl) return null;
    let err = stepEl.querySelector('.fgc-step-error');
    if (err) return err;

    const optionsWrap = stepEl.querySelector('.fgc-options');
    if (!optionsWrap) return null;

    err = document.createElement('p');
    err.className = 'fgc-step-error';
    err.style.cssText = 'display:none;color:#ff6b6b;margin-top:10px;font-size:14px;';
    optionsWrap.insertAdjacentElement('afterend', err);
    return err;
  }

  function setStepError(stepEl, msg) {
    const el = stepErrorEl(stepEl);
    if (!el) return;
    el.textContent = msg || STEP_ERR_TEXT;
    el.style.display = 'block';
  }

  function hideStepError(stepEl) {
    const el = stepEl?.querySelector('.fgc-step-error');
    if (el) el.style.display = 'none';
  }

  // ===== Lead form errors (p tags exist) =====
  const leadErrSel = {
    name: '.fgc-form-error-name',
    email: '.fgc-form-error-email',
    phone: '.fgc-form-error-phone'
  };

  function clearLeadErrors(form) {
    Object.values(leadErrSel).forEach(sel => {
      const el = form?.querySelector(sel);
      if (el) { el.style.display = 'none'; el.textContent = ''; }
    });
  }

  function showLeadError(form, field, msg) {
    const el = form?.querySelector(leadErrSel[field]);
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  // ===== Validation step =====
  function validateCurrentStep() {
    const stepEl = steps[idx];
    if (!stepEl) return true;

    const radios = stepEl.querySelectorAll('.fgc-option input[type="radio"]');
    if (!radios.length) return true;

    const checked = [...radios].find(r => r.checked);
    if (!checked) { setStepError(stepEl); return false; }

    hideStepError(stepEl);
    formData.steps['step_' + (idx + 1)] = checked.value;
    return true;
  }

  // ===== Validation lead form =====
  function validateLeadForm() {
    const form = root.querySelector('.fgc-lead__form');
    if (!form) return true;

    const nameInput = form.querySelector('input[name="name"]');
    const emailInput = form.querySelector('input[name="email"]');
    const phoneInput = form.querySelector('input[name="phone"]');
    const notesEl = form.querySelector('textarea[name="notes"]');

    clearLeadErrors(form);

    const name = (nameInput?.value || '').trim();
    const email = (emailInput?.value || '').trim();
    const phone = (phoneInput?.value || '').trim();
    const notes = (notesEl?.value || '').trim();

    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    let firstBad = null;

    if (!name) { showLeadError(form, 'name', 'Please enter your name'); firstBad ||= nameInput; }
    if (!email) { showLeadError(form, 'email', 'Please enter your email'); firstBad ||= emailInput; }
    else if (!emailOk) { showLeadError(form, 'email', 'Please enter a valid email'); firstBad ||= emailInput; }
    if (!phone) { showLeadError(form, 'phone', 'Please enter your phone number'); firstBad ||= phoneInput; }

    if (firstBad) { firstBad.focus(); return false; }

    formData.name = name;
    formData.email = email;
    formData.phone = phone;
    formData.notes = notes;

    return true;
  }

  // ===== Submit: redirect to /pages/contact and auto-submit there =====
  function sendEmail() {
    if (!validateLeadForm()) return false;

    let message = `PC Builder selections:\n`;
    Object.keys(formData.steps).forEach(k => (message += `${k}: ${formData.steps[k]}\n`));
    message += `\nContact phone: ${formData.phone}`;
    if (formData.notes) message += `\nNotes: ${formData.notes}`;

    localStorage.setItem('fgc_form_data', JSON.stringify({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      notes: formData.notes,
      selections: formData.steps
    }));
    localStorage.setItem('fgc_form_message', message);

    sessionStorage.setItem('fgc_contact_autosubmit', '1');

    // IMPORTANT: reset “submitted once” so next time still works
    sessionStorage.removeItem('fgc_contact_autosubmitted_once');

    const params = new URLSearchParams({
      fgc_autosubmit: '1',
      name: formData.name,
      email: formData.email
    });

    window.location.href = `/pages/contact?${params.toString()}#contact_form`;
    return false;
  }

  // ===== Progress/step show logic =====
  function debounce(fn, t) { let id; return () => { clearTimeout(id); id = setTimeout(fn, t); }; }

  function updateProgress() {
    if (!bar || !track) return;

    if (idx >= TOTAL_PROGRESS) { track.style.display = 'none'; return; }
    track.style.display = '';

    const pct = ((idx + 1) / TOTAL_PROGRESS) * 100;
    bar.style.width = pct + '%';

    const isFinal = (idx === TOTAL_PROGRESS - 1);
    bar.style.borderTopRightRadius = isFinal ? '15px' : '0';
    bar.style.borderBottomRightRadius = isFinal ? '15px' : '0';
  }

  function show(i) {
    idx = Math.max(0, Math.min(i, steps.length - 1));

    if (window.innerWidth <= 1023) {
      const y = window.scrollY;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === idx));
      window.scrollTo(0, y);
    }

    updateProgress();
  }

  function applyMode() {
    if (window.innerWidth <= 1023) {
      show(idx);
    } else {
      steps.forEach(s => s.classList.add('is-active'));
      updateProgress();
    }
  }

  function goNext(triggerCarousel) {
    if (!validateCurrentStep()) return;

    if (idx < steps.length - 1) show(idx + 1);
    else track && (track.style.display = 'none');

    if (triggerCarousel) {
      syncing = true;
      root.querySelector('.prev-next-button--next')?.click();
    }
  }

  // ===== Events =====
  root.addEventListener('change', (e) => {
    const radio = e.target.closest('.fgc-option input[type="radio"]');
    if (radio) {
      const stepEl = radio.closest('.fgc-step');
      hideStepError(stepEl);
      const si = steps.indexOf(stepEl);
      if (si >= 0) formData.steps['step_' + (si + 1)] = radio.value;
      return;
    }

    const form = root.querySelector('.fgc-lead__form');
    if (!form) return;

    const field =
      e.target.matches('input[name="name"]') ? 'name' :
      e.target.matches('input[name="email"]') ? 'email' :
      e.target.matches('input[name="phone"]') ? 'phone' : null;

    if (!field) return;
    const el = form.querySelector(leadErrSel[field]);
    if (el) { el.style.display = 'none'; el.textContent = ''; }
  });

  root.addEventListener('click', (e) => {
    const cta = e.target.closest('.fgc-cta');
    if (cta) {
      e.preventDefault();
      e.stopPropagation();
      return window.innerWidth <= 1023 ? (validateCurrentStep() && show(idx + 1)) : goNext(true);
    }

    const submitBtn = e.target.closest('.fgc-lead__submit');
    if (submitBtn) {
      e.preventDefault();
      e.stopPropagation();
      return sendEmail();
    }

    if (e.target.closest('.prev-next-button--next')) {
      if (syncing) { syncing = false; return; }
      return goNext(false);
    }

    if (e.target.closest('.prev-next-button--prev')) {
      track && (track.style.display = '');
      show(idx - 1);
    }
  });

  window.addEventListener('resize', debounce(applyMode, 120));
  applyMode();
})();

/* Step 4 images */
document.addEventListener("DOMContentLoaded", () => {
  const step4 = document.querySelector(".fgc-step:nth-child(4)");
  if (!step4) return;

  const images = step4.querySelectorAll(".fgc-image-1, .fgc-image-2, .fgc-image-3");
  const options = step4.querySelectorAll(".fgc-option input");

  const hideAll = () => images.forEach(img => img.style.display = "none");

  hideAll();
  const img1 = step4.querySelector(".fgc-image-1");
  if (img1) img1.style.display = "block";

  options.forEach((opt, index) => {
    opt.addEventListener("click", () => {
      hideAll();
      const img = step4.querySelector(`.fgc-image-${index + 1}`);
      if (img) img.style.display = "block";
    });
  });
});


/* =========================
   2) CONTACT PAGE AUTOSUBMIT + SUCCESS LIGHTBOX (FIX SPINNER STUCK)
   Key changes:
   - Submit via form.requestSubmit() (NOT click button) to avoid theme loader “stuck” when submit is blocked
   - If validation fails -> reportValidity and DO NOT trigger loader
   - If submit gets prevented / blocked and theme set aria-busy => force reset after timeout
========================= */
(function () {
  const path = window.location.pathname || '';
  if (!/\/(pages\/contact|contact)\/?$/.test(path)) return;

  const url = new URL(window.location.href);
  const qsAuto = url.searchParams.get('fgc_autosubmit') === '1';
  const ssAuto = sessionStorage.getItem('fgc_contact_autosubmit') === '1';

  // success markers (theme-dependent)
  const posted =
    url.searchParams.get('contact_posted') === 'true' ||
    url.searchParams.get('contact_posted') === '1' ||
    url.searchParams.get('success') === 'true';

  function showSuccess(msg) {
    const overlay = document.createElement('div');
    overlay.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;';
    overlay.innerHTML = `
      <div style="max-width:520px;width:100%;background:#111;border:1px solid rgba(255,255,255,.15);border-radius:14px;padding:18px;box-shadow:0 10px 40px rgba(0,0,0,.45);color:#fff;">
        <div style="font-weight:700;font-size:18px;margin-bottom:8px;">Success</div>
        <div style="font-size:15px;line-height:1.45;color:rgba(255,255,255,.9);margin-bottom:14px;">${msg}</div>
        <div style="display:flex;justify-content:flex-end;">
          <button type="button" data-close="1" style="cursor:pointer;border:0;border-radius:999px;padding:10px 16px;font-weight:700;background:#7c3aed;color:#fff;">OK</button>
        </div>
      </div>
    `;
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay || e.target?.dataset?.close === '1') overlay.remove();
    });
    document.body.appendChild(overlay);
  }

  // If already posted => show success and clean flags
  if (posted) {
    sessionStorage.removeItem('fgc_contact_autosubmit');
    sessionStorage.removeItem('fgc_contact_autosubmitted_once');

    try {
      url.searchParams.delete('fgc_autosubmit');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    showSuccess('Thank you, your information has been sent successfully.');
    return;
  }

  // Not autosubmit flow => stop
  if (!qsAuto && !ssAuto) return;

  // prevent double-run same load
  if (sessionStorage.getItem('fgc_contact_autosubmitted_once') === '1') return;
  sessionStorage.setItem('fgc_contact_autosubmitted_once', '1');

  // Read payload
  let data = null;
  try { data = JSON.parse(localStorage.getItem('fgc_form_data') || 'null'); } catch (e) {}
  const message = localStorage.getItem('fgc_form_message') || '';

  // Find form
  const form =
    document.querySelector('form[action^="/contact"]') ||
    document.querySelector('form[action*="contact"]') ||
    document.querySelector('form#ContactForm');

  if (!form) return;

  // Scroll to form (optional, helps themes init validators)
  try {
    const rect = form.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight) {
      form.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  } catch (e) {}

  const setVal = (selectors, val) => {
    if (val == null) return false;
    const v = String(val);
    if (v.trim() === '') return false;
    for (const sel of selectors) {
      const el = form.querySelector(sel);
      if (el) { el.value = v; return true; }
    }
    return false;
  };

  const name = (data?.name || url.searchParams.get('name') || '').trim();
  const email = (data?.email || url.searchParams.get('email') || '').trim();
  const phone = (data?.phone || '').trim();
  const notes = (data?.notes || '').trim();

  // Fill required Shopify fields
  setVal(['input[name="contact[name]"]', '#ContactFormName', 'input[name="name"]'], name);
  setVal(['input[name="contact[email]"]', '#ContactFormEmail', 'input[name="email"]'], email);

  // Phone: try theme field first
  const phoneSet = setVal(
    [
      'input[name="contact[Phone Number]"]',
      '#contact-form-phone-number',
      'input[name="contact[phone]"]',
      'input[name="contact[telephone]"]',
      '#ContactFormPhone',
      'input[name="contact[Phone]"]',
      'input[name="phone"]',
      'input[type="tel"]'
    ],
    phone
  );

  // Body/message always set (so email contains phone anyway)
  let body = (message || '').trim();
  if (!body) {
    body = `PC Builder request\n`;
    if (phone) body += `Phone: ${phone}\n`;
    if (notes) body += `Notes: ${notes}\n`;
  } else {
    if (!phoneSet && phone && !/phone\s*:/i.test(body)) body += `\nPhone: ${phone}`;
    if (notes && !/notes\s*:/i.test(body)) body += `\nNotes: ${notes}`;
  }
  setVal(
    ['textarea[name="contact[body]"]', '#ContactFormBody', 'textarea[name="body"]', 'textarea[name="message"]'],
    body
  );

  // ===== FIX 1: validate BEFORE triggering theme loader =====
  // If invalid => show browser validation UI and stop (no spinner stuck)
  try {
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      sessionStorage.removeItem('fgc_contact_autosubmitted_once'); // allow retry after user fixes
      return;
    }
  } catch (e) {}

  // ===== FIX 2: submit WITHOUT clicking the theme button =====
  // requestSubmit triggers native submit flow but avoids “click loader” edge-cases
  const submitBtn = form.querySelector('[type="submit"]');

  // If theme has loader button and it still gets stuck, we force reset after timeout
  const resetLoaderIfStuck = () => {
    // common patterns
    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'false');
      submitBtn.classList.remove('is-loading', 'loading', 'disabled');
      submitBtn.disabled = false;

      // hide known loader spans if any
      const loader =
        submitBtn.querySelector('.loader-button__loader') ||
        submitBtn.querySelector('.loading-overlay__spinner') ||
        submitBtn.querySelector('.icon-spinner');
      if (loader) loader.style.display = 'none';
    }
  };

  // Detect “submit prevented” (page doesn’t navigate) -> reset loader
  // NOTE: if submit succeeds, page will reload and this timer is irrelevant
  setTimeout(() => {
    // still same URL, still here => likely blocked by validation/recaptcha/JS preventDefault
    resetLoaderIfStuck();
    // allow manual click retry
    sessionStorage.removeItem('fgc_contact_autosubmitted_once');
  }, 2500);

  try {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitBtn || undefined);
    } else {
      // fallback
      form.submit();
    }
  } catch (e) {
    // hard fallback + reset
    try { form.submit(); } catch (e2) {}
    setTimeout(resetLoaderIfStuck, 500);
    sessionStorage.removeItem('fgc_contact_autosubmitted_once');
  }
})();

